import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { VendorListPage } from '../../../pages/sinister/VendorList';

const NewComplaintPage = lazy(() => import('../../../pages/sinister').then(module => ({default: module.NewComplaintPage})));
const ClaimListPage = lazy(() => import('../../../pages/sinister').then(module => ({default: module.ClaimListPage})));
const ClaimDetailPage = lazy(() => import('../../../pages/sinister').then(module => ({default: module.ClaimDetail})));

export const sinisterChildrenRoutes = [
  {
    path: '',
    element: <Navigate to={'nueva-denuncia'} />,
  },
  {
    path: 'nueva-denuncia',
    element: <NewComplaintPage />,
  },
  {
    path: 'listado-siniestros',
    element: <ClaimListPage title='Listado de Siniestros'/>,
  },
  {
    path: 'detalle-de-siniestro/:id',
    element: <ClaimDetailPage title='Detalle de Siniestro' />,
  },
  {
    path: 'listado-proveedores',
    element: <VendorListPage title='Listado de Proveedores'/>,
  },
];
